import './Updates.css';

import useMeta from '../../../hooks/useMeta';

import { Link } from "react-router-dom";

import Footer from "../../../CommonComponent/Footer/footer";
import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

const Updates = () => {

    const Data = [
        {
            title: "TWC March 2026",
            url: "/Documnets/TWC_Mar26.pdf",
        },
        {
            title: "Investors Presentation November 2025",
            url: "/updates/investors-presentation-nov-25",
        },
        {
            title: "Investors Presentation June 2025",
            url: "/updates/investors-presentation",
        },
        {
            title: "Press Release_Smart Home Expo 2025",
            url: "/Content/Press%20Release%20-%2006052025%20S%201.pdf",
        },
        {
            title: "Incorporation of Subsidiary - Callistus Window Fashion USA Inc",
            url: "/Content/Incorporation%20of%20Subsidiary_Callistus%20Window%20Fashion%20USA%20Inc%201.pdf",
        },
        {
            title: "Investors Meet Intimation 28_02_2025",
            url: "/Content/Intimation-Investors-Meet.pdf",
        },
        {
            title: "Press Release - New Product Launch Dated 03_02_2025",
            url: "/Content/Press-Release-for-Website-Upload.pdf",
        },
        {
            title: "Investor Meet Intimation 20.12.2024",
            url: "/Content/Investor%20Meet%20Intimation%2020_12_2024.pdf",
        },
        {
            title: "Investors Presentation November 2024",
            url: "/updates/investors-presentation-new",
        },
        {
            title: "Intimation Board Meeting 18.07.2024",
            url: "/Content/reports.pdf",
        },
        {
            title: "Outcome Analyst Investors Meet dated 24_06_2024",
            url: "/Content/MDL_24062024201556_IM_Outcome_24062024.pdf",
        },
        {
            title: "Investor Presentation June 2024",
            url: "/Content/MarvelDecor-Investor-Presentation-June-2024.pdf",
        },
        {
            title: "Institutional Investor Meet Intimation 24_06_2024",
            url: "/Content/Institutional-Investor-Meet-Intimation-24_06_2024.pdf",
        },
        {
            title: "Institutional Investor Meet Intimation 17_05_2024",
            url: "/Content/Institutional-Investor-Meet-Intimation-17_05_2024.pdf",
        },
        {
            title: "Institutional Investor Meet Intimation 10_04_2024",
            url: "/Content/Institutional_Investor_Meet_Intimation10_04_2024.pdf",
        },
        {
            title: "Institutional Investor Meet Intimation 26_03_2024",
            url: "/Content/Institutional_Investor_Meet_Intimation_26_03_2024.pdf",
        },
        {
            title: "Outcum of Analyst Investor Meet dated 07_02_2024",
            url: "/Content/AnalystInvestorMeetOutcome_07022024.pdf",
        },
        {
            title: "Analyst Investor Meet dated 07_02_2024",
            url: "/Content/Analyst-Investor-Meet-dated-07_02_2024.pdf",
        },
        {
            title: "Investor Presentation January 2024",
            url: "/Content/MarvelDecor-Investor-Presentation-January-2024.pdf",
        },
        {
            title: "Statement of Deviation(s) or Variation(s)",
            url: "/updates/statement-of-deviations-or-variations",
        },
        {
            title: "Analyst Investor Meet Intimation",
            url: "/Content/Analyst_Investor_Meet_Intimation.pdf",
        },
        {
            title: "Book Closure Intimation",
            url: "/Content/Book_Closure_Intimation.pdf",
        },
        {
            title: "Closure of Trading Window",
            url: "/Content/Closure_of_Trading_Window.pdf",
        },
        {
            title: "Code Practices Procedures Fair Disclosure UPSI MDL",
            url: "/Content/Code_Practices_Procedures_Fair_Disclosure_UPSI_MDL.pdf",
        },
        {
            title: "Establish Free Zone BM Outcome",
            url: "/Content/Establish_Free_Zone_BM_Outcome.pdf",
        },
        {
            title: "Further Investment Callistus Blinds Middle East 10042019",
            url: "/Content/FurtherInvestment_Callistus-Blinds-Middle-East_10042019.pdf",
        },
        {
            title: "Incorporation_Investment in CaIIistus Blinds Middle East (FZC)",
            url: "/Content/Incorporation_Investment-in-CaIIistus-Blinds_Middle-East-FZC_24092018.pdf",
        },
        {
            title: "Internal Auditor Clarification",
            url: "/Content/Internal_Auditor_Clarification.pdf",
        },
        {
            title: "Investor Call 20112018",
            url: "/Content/MarvelDecor-Investor-Presentation-January-2024.pdf",
        },
        {
            title: "Investor Meet 04102018",
            url: "/Content/Investor_Meet_04102018.pdf",
        },
        {
            title: "Investor Presentation",
            url: "/Content/Investor_Presentation_27082018.pdf",
        },
        {
            title: "New Fabric Printing Machine Clarification",
            url: "/Content/New_Fabric_Printing_Machine_Clarification.pdf",
        },
        {
            title: "New Fabric Printing Machine Intimation 31082018",
            url: "/Content/New_Fabric_Printing_Machine_Intimation_31082018.pdf",
        },
        {
            title: "Outcome Board Meeting dated 31082018",
            url: "/Content/Outcome_Board_Meeting_dated_31082018.pdf",
        },
        {
            title: "Outcome SecAuditorApp 2019-20",
            url: "/Content/Outcome-SecAuditorApp-2019-20.pdf",
        },
        {
            title: "Acquisition of Share of Callistus UK Limited",
            url: "/Content/acquisition_of_share_of_callistus_uk_limited.pdf",
        },
        {
            title: "Resignation of Company Secretary and Compliance Officer_MDL_30092020",
            url: "/Content/Resignation%20of%20Company%20Secretary%20and%20Compliance%20Officer_MDL_30092020.pdf",
        },
        {
            title: "Further Investment in Subsidiary",
            url: "/Content/further-investment-in-subsidiary.pdf",
        },
        {
            title: "Appointment of Company Secretary and Compliance Officer_MDL_04012024",
            url: "/Content/Joining%20of%20Company%20Secretary%20and%20Compliance%20Officer_MDL_04012024.pdf",
        },
    ];


    function CheckValue(index) {
        return (index % 2 !== 0) ? true : false
    }

    useMeta({
        title: 'Updates | Marvel Blinds',
        description: "Investors Presentation June 2025 Press Release_Smart Home Expo 2025 Incorporation of Subsidiary – Callistus Window Fashion USA Inc Investors Meet Intimation 28_02_2025 Press Release – New Product Launch Dated 03_02_2025 Investor Meet Intimation 20.12.2024 Investors Presentation November 2024 Intimation Board Meeting 18.07.2024 Outcome Analyst Investors Meet dated 24_06_2024 Investor Presentation June 2024 Institutional Investor Meet […]",
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/updates`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Updates',
            description:
                "Investors Presentation June 2025 Press Release_Smart Home Expo 2025 Incorporation of Subsidiary – Callistus Window Fashion USA Inc Investors Meet Intimation 28_02_2025 Press Release – New Product Launch Dated 03_02_2025 Investor Meet Intimation 20.12.2024 Investors Presentation November 2024 Intimation Board Meeting 18.07.2024 Outcome Analyst Investors Meet dated 24_06_2024 Investor Presentation June 2024 Institutional Investor Meet […]",
            url: `${process.env.REACT_APP_WEBSITE_URL}/updates`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="Updates_pg_container">
                <h1 className="Updates_pg_title">UPDATES</h1>
                <table className="Updates_pg_table">
                    <tbody>
                        {Data.map((item, index) => (
                            <tr key={index}>
                                <td className={CheckValue(index) === true ? 'Border-none' : 'even-row'}>
                                    <Link target={item.url.startsWith('/Content') ? "__blank" : ''} to={item.url || "#"}>
                                        {item.title}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default Updates;